import React, { ReactNode } from "react";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";
import { cn } from "@/utils/utils";

interface DrawerTitleProps {
  title: string;
  subtitle?: string;
  subtitleIcon?: ReactNode;
  className?: string;
}

export const DrawerTitle: React.FC<DrawerTitleProps> = ({
  title,
  subtitle,
  subtitleIcon,
  className = ""
}) => {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Text variant="smSubtitle">{title}</Text>
      {subtitle && (
        <div className="flex gap-1 flex-row px-[6px] py-1 items-center rounded-sm bg-badges-selected">
          {subtitleIcon && (
            <IconContainer size="sm" color="primary" className="pb-[2px]">
              {subtitleIcon}
            </IconContainer>
          )}
          <Text variant="smBody">{subtitle}</Text>
        </div>
      )}
    </div>
  );
};
